<template>
  <div class="l-learn-abc-options-test">
    <!--内容展示区域 -->
    <div class="content" v-if="element">
      <!-- 不能自动播放时，暂时手动按钮 -->
      <div class="btn-big-play" @click="onHandPlay" v-if="audio.isShowPlay"></div>

      <!-- 选项图 -->
      <div class="select-img" v-if="isImgSelection">
        <div class="img" v-for="item in currentTestItem.attrs.selectionList" :key="item.id" :isScroll="false"
          :style="{ backgroundImage: `url(${item.selectionImageRealUrl})` }"></div>
      </div>
      <!-- 题干图 -->
      <LImage v-else :url="currentTestItem.realQuestionImageUrl" :isScroll="false" />
      <!-- 题号 -->
      <LNumber :current="element.currentCount" :total="element.totalCount" class="l-learn-number" />
      <!-- 重复 -->
      <LReplay :play="audio.isPlay" :repeatNumber="element.attrs.repeatQuestionNum - element.repeat" @replay="onReplay"
        class="l-learn-replay" />
    </div>
    <!-- 选项区域 -->
    <LBtnChoice v-if="currentTestItem.attrs" :selections="currentTestItem.attrs.selectionList"
      :active="stage === STAGE_TYPES.isChoose" @select="onSelect" />
  </div>
</template>

<script>
import laudio from '@/utils/laudio'
import version from '@/utils/version'
import LImage from '../../components/l-image'
import LNumber from '../../components/l-number'
import LReplay from '../../components/l-replay'
import LBtnChoice from './components/l-choice'
import { lLoading } from '@/components/l-loading'
import UPModel from '@/models/imgup'
import localKeyLock from '@/utils/localKeyLock'
import { createNamespacedHelpers } from 'vuex'
import elementTypes from '../../../learn-new/minxin/elementTypes'
const { mapGetters, mapActions } = createNamespacedHelpers('course')
const up = new UPModel()

export default {
  name: 'l-learn-abc-options-test',
  components: {
    LImage,
    LNumber,
    LReplay,
    LBtnChoice,
  },
  computed: {
    ...mapGetters(['element']),
    isImgSelection() {
      return this.currentTestItem.attrs
        ? this.currentTestItem.attrs.selectionList[0].selectionImageUrl
        : false
    },
  },
  data() {
    return {
      stage: '',
      currentValueKey: '',
      LOCAL_STAGE_KEY: 'ABC_OPTIONS_TEST_KEY',
      currentTestItem: {}, // 当前题
      STAGE_TYPES: {
        isAudioExplain: 'AUDIO_EXPLAIN', // 题干
        isChoose: 'CHOOSE', // 选择
        isPlayAnswer: 'ANSWER_AUDIO', // 答案音频
      },
      laudio: null,
      selection: null,
      audio: {
        autoplay: true, // 自动播放
        isShowPlay: false, // 播放按钮
        isPlay: false, // 是否播放中
      },
    }
  },
  watch: {
    async 'element.ELEMENT_TYPE'(to) {
      if (to) {
        if (this.element.currentCount > this.element.totalCount) {
          this._next()
          return
        }
        this.currentTestItem = this.element.datas[this.element.currentCount - 1]

        if (this.currentTestItem) {
          this._initLocalKey()
          lLoading.show()
          await this._initSourceUrl()
          lLoading.hide()
          this._initStage()
          setTimeout(() => {
            this._scrollTop()
          }, 800)
        } else {
          console.log('未获得数据')
        }
      }
    },
    stage() {
      switch (this.stage) {
        case this.STAGE_TYPES.isAudioExplain:
          console.log('题干')
          this.audio.isShowPlay = true
          this._initAudio(true)
          break
        case this.STAGE_TYPES.isChoose:
          console.log('选择')
          if (!this.laudio) {
            this._initAudio(false)
            return
          }
          break
        case this.STAGE_TYPES.isPlayAnswer:
          console.log('播放答案')
          this.audio.isShowPlay = true
          if (this.selection) {
            this._initAudio(
              true,
              this.selection.isRight
                ? this.currentTestItem.realRightAudioUrl
                : this.currentTestItem.realWrongAudioUrl
            )
          } else {
            // 刷新导致。直接下一题
            this._localStage()
            this._nextQ()
          }

          break
      }
    },
  },
  mixins: [elementTypes],
  methods: {
    ...mapActions(['STUDY_RESULT', 'STUDY_MEDIA_REPEAT']),
    onSelect(selection) {
      this.selection = selection
      if (this.laudio) {
        this.laudio.pause()
      }
      lLoading.show()
      this.STUDY_RESULT({
        elementId: this.element.id,
        postData: {
          eleId: this.currentTestItem.id,
          option: selection.name,
          right: !!selection.isRight,
          suggestedScore: selection.isRight ? 100 : 0,
        },
      })
        .then(() => {
          lLoading.hide()
          this.stage = this.STAGE_TYPES.isPlayAnswer
        })
        .catch((err) => {
          lLoading.hide()
          this.$lPrompt({
            message: `提交失败,请重新选择：${err.msg || ''}`,
            successTxt: this.$locale.确定,
          })
        })
    },
    onReplay() {
      if (
        this.stage === this.STAGE_TYPES.isChoose &&
        this.laudio &&
        this.element.attrs.repeatQuestionNum - this.element.repeat > 0
      ) {
        this.STUDY_MEDIA_REPEAT({ elementId: this.element.id }).then(() => {
          this.laudio.play()
        })
      }
    },
    onHandPlay() {
      this.laudio.play()
      if (this.stage == this.STAGE_TYPES.isAudioExplain && !version.isPC()) {
        console.log('自动播放失败，设置手动点击播放状态')
        this.isPlayClick = true
      }
    },
    _scrollTop() {
      let scrollHeight = parseInt(window.getComputedStyle(document.querySelector('.l-learn-container')).height)
      let contentHeight = parseInt(window.getComputedStyle(document.querySelector('#app')).height)
      let speed = 10
      let timer = setInterval(() => {
        document.querySelector('#app').scrollTop += speed
        if (document.querySelector('#app').scrollTop >= (scrollHeight - contentHeight)) {
          clearInterval(timer)
          timer = null
        }
      }, 20)
    },
    _initLocalKey() {
      // 当前学习元素+当前题目
      this.currentValueKey = `${this.LOCAL_STAGE_KEY}_${this.element.RECORD_ID}_${this.currentTestItem.id}`
      this.currentValueKey = localKeyLock(
        this.LOCAL_STAGE_KEY,
        this.currentValueKey
      )
    },
    async _initSourceUrl() {
      try {
        let res = await up.resource({
          paths: [
            this.currentTestItem.attrs.questionImageUrl,
            this.currentTestItem.attrs.rightAudioUrl,
            this.currentTestItem.attrs.wrongAudioUrl,
            this.currentTestItem.attrs.questionAudioUrl,
          ],
        })

        this.$set(this.currentTestItem, 'realQuestionImageUrl', res.data[0])
        this.$set(this.currentTestItem, 'realRightAudioUrl', res.data[1])
        this.$set(this.currentTestItem, 'realWrongAudioUrl', res.data[2])
        this.$set(this.currentTestItem, 'realQuestionAudioUrl', res.data[3])

        // 选项图片
        if (this.isImgSelection) {
          let res = await up.resource({
            paths: this.currentTestItem.attrs.selectionList.map((item) => {
              return item.selectionImageUrl
            }),
          })

          res.data.forEach((url, index) => {
            this.$set(
              this.currentTestItem.attrs.selectionList[index],
              'selectionImageRealUrl',
              url
            )
          })
        }
        return true
      } catch (err) {
        this.$lPrompt({
          message: err.msg,
          successTxt: this.$locale.确定,
        })
      }
    },
    _initStage() {
      this.stage = this.STAGE_TYPES.isAudioExplain

      const currentStage = this._getLocalStage()
      if (currentStage) {
        this.stage = currentStage.stage
      }
      this._localStage({ stage: this.stage })
    },
    // 初始化音频
    _initAudio(autoplay, src) {
      this.laudio = laudio({
        autoplay: autoplay == false ? false : this.audio.autoplay,
        src: src || this.currentTestItem.realQuestionAudioUrl,
      })
      if (this.laudio) {
        this._initEvent()
      }
    },
    // 监听事件
    _initEvent() {
      // 监听播放事件
      this.laudio.addEventListener('play', () => {
        this.audio.isShowPlay = false
        this.audio.isPlay = true
        console.log('音频播放', this.stage)
      })

      // 监听暂停事件
      this.laudio.addEventListener('pause', () => {
        this.audio.isPlay = false
        console.log('音频暂停')
      })

      // 播放完成
      this.laudio.addEventListener('ended', () => {
        console.log('播放完成', this.stage)
        if (this.stage === this.STAGE_TYPES.isAudioExplain) {
          this._localStage({ stage: this.STAGE_TYPES.isChoose })
          this.audio.isPlay = false
          // ios系统在手动触发题干音的情况下，题干音播放完刷新页面
          if (this.isPlayClick) {
            console.log('题干播放完成刷新')
            this.isPlayClick = false
            location.reload()
          }
        } else if (this.stage === this.STAGE_TYPES.isPlayAnswer) {
          console.log('答案部分播放完成')
          this._nextQ()
        }
      })
    }, // 缓存当前学习进度，防止刷新丢失
    _localStage(params) {
      if (params) {
        this.stage = params.stage
        localStorage.setItem(this.currentValueKey, JSON.stringify(params))
      } else {
        localStorage.removeItem(this.currentValueKey)
      }
    },
    _getLocalStage() {
      let currentRecord = localStorage.getItem(this.currentValueKey)

      if (currentRecord) {
        currentRecord = JSON.parse(currentRecord)
      }

      return currentRecord
    },
    // 下一题
    _nextQ() {
      this._localStage()
      if (this._isDone()) {
        this._localStage()
        this._next()
      } else {
        location.reload()
      }
    },
    // 所有测评全部完成，
    _isDone() {
      if (this.element.currentCount >= this.element.totalCount) {
        return true
      }
      return false
    },
    // 全部完成，下一个节点
    _next() {
      this.$emit('next')
    },
  },
  destroyed() {
    if (this.laudio) {
      this.laudio.pause()
    }
  },
}
</script>

<style lang="stylus">
@import 'index.styl'
</style>
